// Cookie Consent Fix for Van Ark
// This script helps ensure cookie consent is properly saved

(function() {
  'use strict';

  // Check if we're dealing with Shopify's Customer Privacy API
  if (window.Shopify && window.Shopify.customerPrivacy) {
    console.log('[Cookie Fix] Shopify Customer Privacy API detected');
    
    // Listen for consent accepted events
    document.addEventListener('visitorConsentCollected', function(event) {
      console.log('[Cookie Fix] Consent collected:', event.detail);
      
      // Force save to localStorage as backup
      try {
        localStorage.setItem('shopify_cookie_consent', JSON.stringify({
          analytics: event.detail.analyticsAllowed,
          marketing: event.detail.marketingAllowed,
          preferences: event.detail.preferencesAllowed,
          saleOfData: event.detail.saleOfDataAllowed,
          timestamp: Date.now()
        }));
        console.log('[Cookie Fix] Consent saved to localStorage');
      } catch (e) {
        console.error('[Cookie Fix] Failed to save consent to localStorage:', e);
      }
    });
  }

  // Check for common third-party cookie consent solutions
  const checkForConsentBanner = setInterval(function() {
    // Look for common cookie banner elements
    const banners = document.querySelectorAll('[class*="cookie"], [class*="consent"], [id*="cookie"], [id*="consent"]');
    
    if (banners.length > 0) {
      console.log('[Cookie Fix] Cookie banner elements found:', banners.length);
      
      // Check if consent is already saved
      const savedConsent = localStorage.getItem('shopify_cookie_consent') || 
                          localStorage.getItem('cookie_consent') ||
                          localStorage.getItem('cookieConsent');
      
      if (savedConsent) {
        console.log('[Cookie Fix] Saved consent found:', savedConsent);
      }
      
      clearInterval(checkForConsentBanner);
    }
  }, 1000);

  // Stop checking after 10 seconds
  setTimeout(function() {
    clearInterval(checkForConsentBanner);
  }, 10000);

  // Helper function to debug localStorage issues
  window.debugCookieConsent = function() {
    console.log('=== Cookie Consent Debug Info ===');
    console.log('localStorage available:', typeof Storage !== 'undefined');
    console.log('Cookies enabled:', navigator.cookieEnabled);
    
    // Check all cookie-related localStorage items
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.includes('cookie') || key.includes('consent') || key.includes('privacy'))) {
        console.log(key + ':', localStorage.getItem(key));
      }
    }
    
    // Check Shopify Customer Privacy
    if (window.Shopify && window.Shopify.customerPrivacy) {
      console.log('Current consent:', window.Shopify.customerPrivacy.currentVisitorConsent());
    }
    
    console.log('=================================');
  };

})();

